import React, { useCallback, useState } from 'react';

import { EditOutlined } from '@ant-design/icons';
import { Button, Drawer, Row, Col } from 'antd';

import MyCollapse from 'components/Collapse';
import CustomCopyToClipboard from 'components/CustomCopyToClipboard';
import Truncate from 'components/Truncate';
import PermissionHide from 'v2/components/Shared/PermissionHide';
import { useUserStore } from 'v2/store/User';

import CampaignForm from '../CampaignForm';
import TrackerForm from '../TrackerForm';

interface IProps {
  active: boolean;
  product: any;
  campaign: any;
  changeActive: any;
  updateListCampaigns: any;
}

const QuickView: React.FC<IProps> = ({ active, product, campaign, changeActive, updateListCampaigns }) => {
  const [activeCampaignForm, setActiveCampaignForm] = useState(false);
  const [activeTrackerForm, setActiveTrackerForm] = useState(false);

  const { currentUserId } = useUserStore(({ user }) => ({ currentUserId: user.id }));

  const handleCloseQuickView = useCallback(() => {
    changeActive();
  }, [changeActive]);

  const openEditForm = useCallback(() => {
    setActiveCampaignForm(true);
  }, []);

  const closeEditForm = useCallback(
    (saved?: boolean) => {
      setActiveCampaignForm(false);

      if (saved === true) {
        handleCloseQuickView();
      }
    },
    [handleCloseQuickView]
  );

  const closeTrackerForm = useCallback(() => {
    setActiveTrackerForm(false);
  }, []);

  return (
    <div>
      <Drawer
        onClose={handleCloseQuickView}
        placement='right'
        open={active}
        styles={{ body: { padding: 0 } }}
        width={450}
        rootClassName='max-[1024px]:[&_.ant-drawer-content-wrapper]:w-full!'
        title={product?.title ?? 'Carregando...'}
      >
        <div className='p-4'>
          <Row justify='space-between' align='middle'>
            <Col xs={8} sm={12}>
              <div className='product__name' title={campaign.title ? campaign.title : 'Produto desconhecido'}>
                <Truncate count={40} final={'...'}>
                  {campaign.title ? campaign.title : 'Produto desconhecido'}
                </Truncate>
              </div>
            </Col>

            <Col xs={16} sm={12} style={{ textAlign: 'right' }}>
              <PermissionHide action='myeduzz:links:editar'>
                <Button
                  type='text'
                  size='small'
                  onClick={openEditForm}
                  style={{ color: '#596375', fontSize: 12, fontWeight: 600 }}
                >
                  <EditOutlined style={{ fontSize: 12, color: '#596375', marginRight: '0.5rem' }} />
                  Editar
                </Button>
              </PermissionHide>
            </Col>
          </Row>

          <Row>
            <Col span={24}>
              {campaign.active ? (
                <span className='tgreen'>
                  <strong>Ativa</strong>
                </span>
              ) : (
                <span className='tred'>Inativa</span>
              )}
            </Col>
          </Row>

          <Row gutter={16}>
            <Col sm={12} xs={24} style={{ padding: '5px 12px' }}>
              <div style={{ padding: 0, fontWeight: 600, color: '#192542', fontSize: '0.875rem' }}>
                RPC A: <span style={{ float: 'right', fontWeight: 'normal' }}>{campaign.rpc_affiliate}</span>
              </div>
            </Col>
            <Col sm={12} xs={24} style={{ padding: '5px 12px' }}>
              <div style={{ padding: 0, fontWeight: 600, color: '#192542', fontSize: '0.875rem' }}>
                RPC P: <span style={{ float: 'right', fontWeight: 'normal' }}>{campaign.rpc_producer}</span>
              </div>
            </Col>
            <Col sm={12} xs={24} style={{ padding: '5px 12px' }}>
              <div style={{ padding: 0, fontWeight: 600, color: '#192542', fontSize: '0.875rem' }}>
                Cliques: <span style={{ float: 'right', fontWeight: 'normal' }}>{campaign.clicks}</span>
              </div>
            </Col>
            <Col sm={12} xs={24} style={{ padding: '5px 12px' }}>
              <div style={{ padding: 0, fontWeight: 600, color: '#192542', fontSize: '0.875rem' }}>
                Conversões: <span style={{ float: 'right', fontWeight: 'normal' }}>{campaign.conversion}</span>
              </div>
            </Col>
          </Row>

          <div className='mt-12 md:mt-6' />

          <div>
            <MyCollapse
              title='Script de marcação'
              icon={<span style={{ fontSize: 16 }}>🎯</span>}
              arrow={true}
              contentActive={false}
            >
              <CustomCopyToClipboard
                style={{ width: '100%', fontSize: 11 }}
                text={`<script>
                    (function(i,s,o,g,c,f,r,a,m)
                    {i['edzpx_c']=c;i['edzpx_a']=f;i['PxEdz']=r;i[r]=i[r]||
                    function(){(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();
                    a=s.createElement(o),m=s.getElementsByTagName(o)[0]||
                    s.getElementsByTagName('head')[0];
                    e='https://e';g=e+'duzz'+'.'+String.fromCharCode(105, 110, 102, 111)+'/'+g;a.async=1;
                    a.src=g;m.parentNode.insertBefore(a,m)})(window,document,'script','dev/js/px.js','${campaign.key}',${currentUserId},'edzpx');</script>`}
              />
              <p style={{ marginTop: 5, fontSize: 14, color: '#888' }}>
                Clique{' '}
                <a
                  href='https://ajuda.eduzz.com/hc/pt-br/articles/1260807655830-como-marcar-tr%C3%A1fego-com-script'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  aqui
                </a>{' '}
                e veja instruções de como usar.
              </p>
            </MyCollapse>
          </div>

          <div className='mt-2' />

          <div>
            <MyCollapse
              title='Script de Funil Infinito'
              icon={<span style={{ fontSize: 16 }}>🔷</span>}
              arrow={true}
              contentActive={false}
            >
              <CustomCopyToClipboard
                style={{ width: '100%', fontSize: 11 }}
                text={`<script>
                    var funnel_key = '${campaign.key}';
                    var funnel_level = '0';
                    var field_email = 'email';
                    var edz_loadscript = document.createElement('script');
                    edz_loadscript.src = 'https://eduzz.com/dev/js/ea.js?v=1.0';
                    document.getElementsByTagName('head')[0].appendChild(edz_loadscript);
                    </script>`}
              />
              <p style={{ marginTop: 5, fontSize: 14, color: '#888' }}>
                Clique{' '}
                <a
                  href='https://ajuda.eduzz.com/hc/pt-br/articles/4402979200027-o-que-%C3%A9-um-funil-infinito-myeduzz'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  aqui
                </a>{' '}
                e veja instruções de como usar.
              </p>
            </MyCollapse>
          </div>
        </div>
      </Drawer>

      {activeCampaignForm && (
        <CampaignForm
          open={activeCampaignForm}
          handleClose={closeEditForm}
          product={product}
          campaign={campaign}
          updateListCampaigns={updateListCampaigns}
        />
      )}
      {activeTrackerForm && (
        <TrackerForm open={activeTrackerForm} handleClose={closeTrackerForm} product={product} campaign={campaign} />
      )}
    </div>
  );
};

export default QuickView;
